import React, { useState } from 'react'
import {
  ProductPackage,
  ProductPreset,
} from 'services/api/entities/catalog/packages/common'
import KAccordion from 'ui-shared/accordions/KAccordion'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import { getById } from 'services/utils'
import {
  pkgByCustomersAndOrgs,
  ProductPackageWithMinAndMaxQuantity,
} from './package/common'
import ProductPackageBaseFormContent, {
  GenericChoiceTailored,
} from '../ProductPackageBaseFormContent'
import { Container, Grid, Box, Switch } from '@mui/material'

type PackageProps<T, S> = {
  packages: ProductPackageWithMinAndMaxQuantity[]
  choices: T[]
  source: string
  title: string
  formDataPackage: S | number | undefined | ''
  children?: React.ReactElement
  presetsReadOnlyComponent: React.ReactElement
  isToggleBundleVisible?: boolean
  presetInputFields: React.ReactElement
  eventPkgCustomers: number[]
  eventPkgOrgs: number[]
}
const EventPackageFormPackageAccordion = <
  T extends GenericChoiceTailored,
  S extends ProductPackage<ProductPreset>
>({
  packages,
  source,
  title,
  choices,
  formDataPackage,
  presetsReadOnlyComponent,
  presetInputFields,
  isToggleBundleVisible = false,
  eventPkgCustomers = [],
  eventPkgOrgs = [],
}: PackageProps<T, S>) => {
  const [active, setActive] = useState(false)
  const packageSelect =
    !active && typeof formDataPackage === 'number'
      ? getById(packages, formDataPackage)
      : undefined

  const filteredPackages = pkgByCustomersAndOrgs(
    packages,
    eventPkgCustomers,
    eventPkgOrgs
  )

  return (
    <KAccordion accordionTitle={title} key={source}>
      <Container>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <p>Open Create Package</p>
            <Switch
              name="newPackage"
              checked={active}
              onChange={() => setActive(!active)}
            />
          </Box>
        </Grid>
        {!active ? (
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12}>
              <LocalizedSelectInput
                label={packageSelect?.name}
                source={source}
                resettable
                choices={filteredPackages}
                style={{ maxWidth: '350px', width: '100%' }}
              />
            </Grid>
            {React.cloneElement(presetsReadOnlyComponent, {
              pkg: packageSelect,
            })}
          </Grid>
        ) : (
          <ProductPackageBaseFormContent
            choices={choices}
            eventPkgCustomers={eventPkgCustomers}
            eventPkgOrgs={eventPkgOrgs}
            presetInputFields={presetInputFields}
            source={`${source}.`}
            isToggleBundleVisible={isToggleBundleVisible}
          />
        )}
      </Container>
    </KAccordion>
  )
}
export default EventPackageFormPackageAccordion
